<div class="position-relative d-flex flex-column containers">
    <div class="fixed-header">
        <div *ngIf="!isLIC" class="title-container px-3">
            <button type="button" [routerLink]="patientDashboardRoute" mat-icon-button
                aria-label="Back to patient dashboard">
                <mat-icon>arrow_back_ios</mat-icon>
            </button>
            <div class="title">Appointment</div>
            <div class="d-md-none user-profile p-2">
                <mat-icon [matMenuTriggerFor]="userMenu" class="pointer">person_outline</mat-icon>
                <mat-menu #userMenu="matMenu" xPosition="after" class="user-menu-collapse">
                    <cva-side-nav-user-menu-items></cva-side-nav-user-menu-items>
                </mat-menu>
            </div>
        </div>

        <div class="d-lg-flex justify-content-between consultation-header-row">
            <cva-patient-banner *ngIf="appointment" [appointment]="appointment"
                (callGotoBrowser)="gotoTemplateManagement()">
            </cva-patient-banner>

            <!-- Disclaimer shown for large screen -->
            <div id="Disclaimer-lg-sc" class="d-none d-sm-block  justify-content-end soap-header gap-3 ">
                <div class="alert alert-warning disclaimer-alert float-end" role="alert">
                    <strong>Disclaimer:</strong> {{CVA_CONSTANTS.MESSAGE.CONSULTATION_DISCLAIMER}}&nbsp;<a
                        class="policy-clr" [href]="PRIVACY_POLICY_ROUTE" target="_blank"
                        rel="noopener noreferrer">Privacy Policy</a>
                    <div class="float-end ms-3" *ngIf="false">
                        <mat-icon [matMenuTriggerFor]="helpMenu1" class="pointer">help</mat-icon>
                        <mat-menu #helpMenu1="matMenu">
                            <button mat-menu-item (click)="openTutorialVideo()">
                                <mat-icon>movie</mat-icon>
                                <span>Watch Tutorial</span>
                            </button>
                            <button mat-menu-item>
                                <mat-icon>mail</mat-icon>
                                <a href="mailto:help@intellitekhealth.com" class="text-reset text-decoration-none"
                                    target="_blank">Contact Us</a>
                            </button>
                        </mat-menu>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex flex-column overflow-hidden min-h-0 flex-1" [ngClass]="{'flex-1 overflow-x-hidden' : isLIC}">
            <div class="top-tab-toggle mx-2 mt-2">
                <button type="button" class="top-tab-btn" [class.active]="activeTopTab === topTab.Consultation"
                    (click)="setActiveTopTab(topTab.Consultation)">
                    <span class="top-tab-btn-content">
                        <span>Consultation</span>
                        <mat-icon *ngIf="isConsultationRecording" class="recording-tab-icon"
                            aria-hidden="true">fiber_manual_record</mat-icon>
                    </span>
                </button>
                <button type="button" class="top-tab-btn" [class.active]="activeTopTab === topTab.PatientSummary"
                    (click)="setActiveTopTab(topTab.PatientSummary)">
                    Patient Dashboard
                </button>
                <button type="button" class="top-tab-btn" [class.active]="activeTopTab === topTab.ConsultationSummary"
                    (click)="setActiveTopTab(topTab.ConsultationSummary)">
                    Patient Summary
                </button>
                <button *ngIf="!isLicUser" type="button" class="top-tab-btn"
                    [class.active]="activeTopTab === topTab.Appointments" (click)="setActiveTopTab(topTab.Appointments)"
                    cvaAuthPermCheck [moduleName]="CVA_AUTH_MODULES.CVA_APPOINTMENT"
                    [permissionType]="CVA_CONSTANTS.PERMISSION.READ" [actionType]="'hide'">
                    Appointments
                </button>
            </div>

            <!-- Disclaimer shown for small screen -->
            <div id="Disclaimer-sm-sc" class="d-block d-sm-none soap-header gap-3 ">
                <div class="alert alert-warning disclaimer-alert float-end" role="alert">
                    <strong>Disclaimer:</strong> {{CVA_CONSTANTS.MESSAGE.CONSULTATION_DISCLAIMER}}&nbsp;<a
                        class="policy-clr" [href]="PRIVACY_POLICY_ROUTE" target="_blank"
                        rel="noopener noreferrer">Privacy Policy</a>
                    <div class="float-end ms-3" *ngIf="false">
                        <mat-icon [matMenuTriggerFor]="helpMenu1" class="pointer">help</mat-icon>
                        <mat-menu #helpMenu1="matMenu">
                            <button mat-menu-item (click)="openTutorialVideo()">
                                <mat-icon>movie</mat-icon>
                                <span>Watch Tutorial</span>
                            </button>
                            <button mat-menu-item>
                                <mat-icon>mail</mat-icon>
                                <a href="mailto:help@intellitekhealth.com" class="text-reset text-decoration-none"
                                    target="_blank">Contact Us</a>
                            </button>
                        </mat-menu>
                    </div>
                </div>
            </div>

            <div class="consultation-body tab-content custom-border mx-2 m-h-0 flex-1"
                *ngIf="viewMode === VIEW_MODE.TAB" [class.d-none]="activeTopTab !== topTab.Consultation"
                [attr.aria-hidden]="activeTopTab !== topTab.Consultation">
                <cva-consultation-tab-view class="h-100 d-flex" [appointment]="appointment" [reaload]="reaload"
                    [selectedTab]="selectedTab" (recordingStateChange)="onConsultationRecordingStateChange($event)"
                    (notesApproved)="onConsultationNotesApproved()"></cva-consultation-tab-view>
            </div>

            <div class="consultation-body tab-content custom-border mx-2 h-100 patient-summary"
                *ngIf="viewMode === VIEW_MODE.TAB && hasPatientSummaryOpened"
                [class.d-none]="activeTopTab !== topTab.PatientSummary"
                [attr.aria-hidden]="activeTopTab !== topTab.PatientSummary">
                <cva-patient-dashboard [selectedPatientIdInput]="appointment.patient.medicalRecordNumber"
                    [refreshTrigger]="patientSummaryRefreshToken"
                    [hideAppointmentsSection]="true"></cva-patient-dashboard>
            </div>

            <div class="consultation-body tab-content custom-border mx-2 h-100 consultation-summary-pane"
                *ngIf="viewMode === VIEW_MODE.TAB && hasConsultationSummaryOpened"
                [class.d-none]="activeTopTab !== topTab.ConsultationSummary"
                [attr.aria-hidden]="activeTopTab !== topTab.ConsultationSummary">
                <cva-consultation-summary-tab [appointment]="appointment"
                    [refreshTrigger]="consultationSummaryRefreshToken"></cva-consultation-summary-tab>
            </div>

            <div class="consultation-body tab-content custom-border mx-2 h-100 patient-summary"
                *ngIf="!isLicUser && viewMode === VIEW_MODE.TAB && activeTopTab === topTab.Appointments">
                <cva-patient-appointment-list
                    [patientIdInput]="appointment.patient.medicalRecordNumber"></cva-patient-appointment-list>
            </div>
        </div>

        <div class="consultation-body grid-content" *ngIf="viewMode === VIEW_MODE.GRID">
            <cva-consultation-grid-view [appointment]="appointment"
                (switchToTabMode)="switchToTabMode()"></cva-consultation-grid-view>
        </div>
    </div>
</div>